import { Link } from "react-router-dom";
import { topics } from "@/mocks/home";

const stats = [
  { value: "128", label: "在追话题", icon: "ri-fire-line" },
  { value: "9.6万", label: "今日站队", icon: "ri-hand-coin-line" },
  { value: "4.2万", label: "条观点评论", icon: "ri-chat-3-line" },
  { value: "312", label: "篇二创解读", icon: "ri-quill-pen-line" },
];

export default function Hero() {
  const featured = topics[0];
  const totalVotes = featured.votesA + featured.votesB;
  const percentA = Math.round((featured.votesA / totalVotes) * 100);

  return (
    <section className="relative w-full overflow-hidden bg-background-50 pt-12 md:pt-16" aria-labelledby="hero-title">
      <div
        className="pointer-events-none absolute -right-24 -top-24 h-[420px] w-[420px] rounded-full bg-primary-100/70 blur-3xl"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -left-32 bottom-0 h-[320px] w-[320px] rounded-full bg-accent-100/60 blur-3xl"
        aria-hidden="true"
      />

      <div className="relative mx-auto grid w-full max-w-[1400px] grid-cols-1 items-center gap-12 px-4 pb-14 md:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16 lg:pb-20">
        <div className="animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5 text-xs font-bold tracking-wide text-primary-700">
            <i className="ri-live-line text-sm" aria-hidden="true" />
            网爆黑料 · 吃瓜群众聚集地
          </span>

          <h1
            id="hero-title"
            className="mt-6 font-heading text-[40px] font-black leading-[1.12] tracking-tight text-foreground-950 md:text-[56px] lg:text-[62px]"
          >
            网爆黑料话题互动区
            <br />
            <span className="text-primary-600">站队、PK、聊个痛快</span>
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600 md:text-[17px]">
            这里是<strong className="font-bold text-foreground-900">网爆黑料</strong>话题的吃瓜主场。
            每个热点都拆成两派观点，你可以站队投票、参与观点 PK、在评论区开麦，也可以读一读
            <strong className="font-bold text-foreground-900">二创解读</strong>，看看别人是怎么把瓜吃出层次的。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#topics"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line text-lg" aria-hidden="true" />
              进入今日瓜田
            </a>
            <a
              href="#pk"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3.5 text-sm font-bold text-foreground-800 transition-colors hover:border-secondary-400 hover:text-secondary-700"
            >
              <i className="ri-sword-line text-lg" aria-hidden="true" />
              去看看观点 PK
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-background-200 pt-8 sm:grid-cols-4">
            {stats.map((stat) => (
              <div key={stat.label}>
                <dt className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <i className={`${stat.icon} text-sm text-accent-600`} aria-hidden="true" />
                  {stat.label}
                </dt>
                <dd className="mt-1.5 font-heading text-2xl font-black text-foreground-950">{stat.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative animate-fade-up">
          <div className="absolute -left-4 -top-4 hidden h-20 w-20 rounded-lg bg-accent-400/80 lg:block" aria-hidden="true" />
          <article className="relative overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="relative h-[220px] w-full md:h-[260px]">
              <img
                src="https://readdy.ai/api/search-image?query=%E6%9A%96%E8%89%B2%E8%88%9E%E5%8F%B0%E7%81%AF%E5%85%89%E4%B8%8E%E6%A4%85%E5%AD%90%E7%9A%84%E7%A9%BA%E6%99%AF%EF%BC%8C%E7%94%B5%E8%A7%86%E7%A7%80%E7%8E%B0%E5%9C%BA%E6%B0%9B%E5%9B%B4%EF%BC%8C%E7%94%BB%E9%9D%A2%E5%B9%B2%E5%87%80%E7%AE%80%E6%B4%81%EF%BC%8C%E8%89%B2%E8%B0%83%E6%B8%A9%E6%9A%96%E7%BA%B9%E7%90%86%E7%BB%86%E8%85%BB&width=900&height=560&seq=gualu-hero-feature&orientation=landscape&nocache=true"
                alt="网爆黑料今日最热话题：综艺现场舞台空景"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/20 to-transparent" aria-hidden="true" />
              <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                <i className="ri-fire-fill text-sm" aria-hidden="true" />
                今日最热
              </span>
              <div className="absolute bottom-4 left-4 right-4">
                <p className="text-xs font-medium text-accent-300">{featured.categoryName} · 热议中</p>
                <h2 className="mt-1 line-clamp-2 font-heading text-lg font-black leading-snug text-background-50 md:text-xl">
                  {featured.title}
                </h2>
              </div>
            </div>

            <div className="p-5 md:p-6">
              <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">{featured.summary}</p>

              <div className="mt-5">
                <div className="flex items-center justify-between text-xs font-medium text-foreground-500">
                  <span>{featured.sideA} {percentA}%</span>
                  <span>已站队 {totalVotes.toLocaleString()} 人</span>
                  <span>{featured.sideB} {100 - percentA}%</span>
                </div>
                <div className="mt-2 flex h-2.5 w-full overflow-hidden rounded-full bg-background-200">
                  <span className="h-full bg-primary-500" style={{ width: `${percentA}%` }} />
                  <span className="h-full bg-secondary-500" style={{ width: `${100 - percentA}%` }} />
                </div>
              </div>

              <Link
                to={`/topic/${featured.id}`}
                className="mt-5 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-foreground-800"
              >
                查看话题详情与评论
                <i className="ri-arrow-right-line text-base" aria-hidden="true" />
              </Link>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}